import {productContentBlockSettings, ProductContentBlockSettings} from '../../../bps/components/productContentBlock/productContentBlockSettings';

productContentBlockSettings.readMoreHeight = 250;
productContentBlockSettings.productlistPageBottomWithCarousel = true;

export {productContentBlockSettings, ProductContentBlockSettings}
